import React, { FC, useEffect, useState } from "react";
import { IUploadReferral } from "../../../interfaces/IReferral";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import {
  completeWizardStep,
  fetchEchsProcedure,
  fetchSchemeById,
  getClaimSubmission,
  resetLocalFiles,
  saveChanges,
  setUploadedDocumentUrl,
  setWizardSteps,
  submitClaimSubmission,
  submitClaimSubmissionToEdgePro,
  toggleEditMode,
  updateClaimSubmission,
  updateEchsClaimDataField,
  updateField,
  updateWizardStep,
  UploadDocument,
} from "../../../models/preAuthClaimSlice";
import { IDocumentFields } from "../../../interfaces/ICase";
import { errorMessage, successMessage } from "../../../utils/notificationUtils";
import {
  IPreAuthClaimState,
  PreAuthClaimField,
  PreAuthClaimResponse,
  PreAuthClaimSection,
} from "../../../interfaces/IPreAuthClaim";
import { message } from "antd";
import FilePreviewModal from "../../../components/patient/PreAuth-query/FilePreviewModal";
import { getPortalData, resetPortalData } from "../../../models/preAuthSlice";
import dayjs from "dayjs";
import PreAuthClaimEchs from "../../../components/patient/PreAuthClaim/PreAuthClaimEchs";
import RightSidePreviewModal from "../../../components/modals/RightSidePreviewModal";
import {
  deleteUploadedDocument,
  downloadDocument,
  submitApproval,
} from "../../../apis/patientService";
import {
  clearDeficiencyCheck,
  getDeficiencyQuestionData,
} from "../../../models/patientSlice";
import Loader from "../../../utils/Spinners";
import DocumentDeficiencyModal from "../../../components/patient/DocumentDeficiencyModal";
import { useLocation } from "react-router-dom";
import { Form } from "antd";

type PreAuthClaimContainerProps = {
  claimId: string | null;
  onfetchStepper: () => void;
  stepperForStatus: CallableFunction;
  nextStage: any;
  setMoveToNext: CallableFunction;
};


const PreAuthClaimContainerEchs: FC<PreAuthClaimContainerProps> = (props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [uploadFileModal, setUploadFileModal] = useState<boolean>(false); //to open a modal of preview
  const { patients, auth, hospital, preAuthClaim, preAuth } = useSelector(
    (state: RootState) => state
  );
  const {
    allWizardSteps,
    activeStep,
    preAuthClaimRes,
    error,
    editMode,
    isSubmit,
  }: IPreAuthClaimState = useSelector((state: RootState) => state.preAuthClaim);
  const [selectedFile, setSelectedFile] = useState<IUploadReferral>({
    file: {},
    documentType: "",
  });
  const [documentUrl, setDocumentUrl] = useState<string>("");
  const [previewDocument, setPreviewDocument] = useState(false);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [newClaimId, setNewClaimId] = useState<string | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [portalSubmission, setPortalSubmission] = useState<string | null>(null);
  const [caseClaimSubmissionId, setCaseClaimSubmissionId] = useState<
    number | null
  >(null);
  const [isEditable, setIsEditable] = useState<boolean>(false);

  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(
    null
  ); //to send document id for deficiency check
  const [documentName, setDocumentName] = useState("");
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [deleteProcedureList, setDeleteProcedureList] = useState<any[]>([]);

  const location = useLocation();
  const path = location.pathname;
  const visitId = path.split("/")[3];
  const [form] = Form.useForm();
  const [isDownloadingDocument, setIsDownloadingDocument] =
    useState<boolean>(false);
  const [downloadingDocumentUrl, setDownloadingDocumentUrl] =
    useState<string>("");

  const parseDate = (dateString: any) => {
    return dayjs(dateString, "DD-MM-YYYY HH:mm:ss", true).isValid()
      ? dayjs(dateString, "DD-MM-YYYY HH:mm:ss") // Custom format
      : dayjs(dateString); // ISO format (parsed automatically)
  };

  useEffect(() => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId &&
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "ECHS" && patients?.fetchBasicDetails?.casesResponse?.healthCareId
    ) {
      dispatch(
        fetchEchsProcedure({
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          patientType:
            patients?.fetchBasicDetails?.visitInfoResponse?.visitType === "OP"
              ? "OP"
              : "IP",
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        })
      );
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.healthCareId,
    patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName,
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
  ]);

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any
  ) => {
    try {
      if (selectedDocumentId) {
        dispatch(clearDeficiencyCheck());
        // const firstRes = await dispatch(
        //   getDeficiencyQuestions(selectedDocumentId)
        // );

        if (selectedDocument?.id) {
          const secondRes = await dispatch(
            getDeficiencyQuestionData(selectedDocument?.id)
          );
        }
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocumentId(null);
      setSelectedDocument(null);
    }
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       if (selectedDocumentId) {
  //         dispatch(clearDeficiencyCheck());
  //         // const firstRes = await dispatch(
  //         //   getDeficiencyQuestions(selectedDocumentId)
  //         // );

  //         if (selectedDocument?.id) {
  //           const secondRes = await dispatch(
  //             getDeficiencyQuestionData(selectedDocument?.id)
  //           );
  //         }
  //       }
  //     } catch (err) {
  //       errorMessage("Please, Try again after sometime");
  //       setSelectedDocumentId(null);
  //       setSelectedDocument(null);
  //     }
  //   };

  //   if (selectedDocumentId || selectedDocument?.id) fetchData();
  // }, [selectedDocumentId, selectedDocument?.id]);

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields
  ) => {
    await fetchDeficiencyData(document, documentId);
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDeficiencyModalAfterSave = async (
    documentUrl: string,
    documentId: number,
    field: any
  ) => {
    const document = {
      id: field?.documentId,
      documentName: field?.documentName,
      documentType: field?.labelId,
      documentUrl: field?.data,
      documentLabelType: field?.label,
      deficiencyCheckStatus: field?.deficiencyCheckStatus,
    };

    await fetchDeficiencyData(document, documentId);
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocumentId(null);
    setSelectedDocument(null);
  };

  const handleCancel = () => {
    setUploadFileModal(false);
  };

  const viewFile = (file: any) => {
    window.open(file, "_blank");
  };
  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };
  const handleSetDocumentUrl = (url: string) => {
    setDocumentUrl(url);
  };

  const handleOpen = () => {
    setPreviewDocument(true);
  };

  const handleNext = async () => {
    // try {
    //   await form.validateFields();
    //   dispatch(updateWizardStep(activeStep + 1));
    // } catch (err: any) {
    //   if (err?.errorFields) {
    //     errorMessage("Please, fill all details before submitting");
    //   }
    // }
    dispatch(updateWizardStep(activeStep + 1));
  };

  const handlePrevious = () => {
    dispatch(updateWizardStep(activeStep - 1));
  };

  const handleComplete = (step: number) => {
    dispatch(completeWizardStep(step));
  };

  const handleTabsChange = (activeStep: string) => {
    dispatch(updateWizardStep(parseInt(activeStep)));
  };

  useEffect(() => {
    dispatch(updateWizardStep(0));
  }, []);

  useEffect(() => {
    if (preAuthClaim && preAuthClaim?.preAuthClaimRes) {
      const preAuthClaimRes: any = preAuthClaim.preAuthClaimRes;
      const initialEditedFields: Record<string, Record<string, any>> = {};
      Object.keys(preAuthClaim?.preAuthClaimRes)?.forEach((resKey) => {
        const sections = preAuthClaimRes[resKey];
        if (sections) {
          Object.keys(sections)?.forEach((key) => {
            const caseType = sections[key as keyof PreAuthClaimResponse];
            if (caseType) {
              //caseType?.forEach((section:any) => {
              Object.entries(caseType)?.forEach(([sectionTitle, fields]) => {
                if (
                  Array.isArray(fields) &&
                  !sectionTitle?.toLowerCase()?.includes("procedure")
                ) {
                  fields?.forEach((field: PreAuthClaimField) => {
                    if (!initialEditedFields[resKey]) {
                      initialEditedFields[resKey] = {};
                    }
                    initialEditedFields[resKey][field?.id] = field?.id
                      ?.toLowerCase()
                      ?.includes("date")
                      ? field?.data
                        ? // ? dayjs(field?.data, "DD-MM-YYYY HH:mm:ss")
                          parseDate(field?.data)
                        : null
                      : field.data ?? null;
                  });
                } else if (
                  sectionTitle?.toLowerCase()?.includes("procedure") &&
                  Array.isArray(fields)
                ) {
                  const items = fields?.map((item) => ({
                    expenseUnit: item?.expenseUnit ?? null,
                    expenseCode: item?.expenseCode ?? null,
                    admissibleRate: item?.admissibleRate ?? null,
                    hospitalRate: item?.hospitalRate ?? null,
                    hospitalAmount: item?.hospitalAmount ?? null,
                    hospitalRemark: item?.hospitalRemark ?? null,
                    id: item?.id ?? null,
                    procedureID: JSON.stringify({
                      rateType: item?.rateType ?? null,
                      expenseType: item?.expenseType ?? null,
                      expenseCode: item?.expenseCode ?? null,
                      procedureID: item?.procedureID ?? null,
                      expenseName: item?.expenseName ?? null,
                      normalRate: item?.normalRate ?? null,
                      admissibleRate: item?.admissibleRate ?? null,
                    }),
                  }));

                  initialEditedFields[resKey] = {
                    ...initialEditedFields[resKey],
                    items: items?.length > 0 ? items : null,
                  };
                }
              });
              //});
            }
          });
        }
      });
      dispatch(
        updateField({
          sectionKey: "all",
          fieldId: "all",
          value: initialEditedFields,
        })
      );
    } else if (caseClaimSubmissionId) {
      setIsEditable(false);
    }
  }, [caseClaimSubmissionId, preAuthClaim?.preAuthClaimRes]);

  const handleDeleteList = async (
    docType: string,
    documentUrl: string,
    idx: number
  ) => {
    const deleteDocument = preAuthClaim?.uploadedDocumentUrl?.find(
      (doc, index) => doc?.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };
    const newUpdatedDocumentList = preAuthClaim?.uploadedDocumentUrl?.filter(
      (doc, index) => doc?.documentUrl !== documentUrl
    );
    dispatch(setUploadedDocumentUrl(newUpdatedDocumentList));
    if (deleteDocument?.documentUrl) {
      const res = await deleteUploadedDocument(deleteForm);

      if (res) {
        if (preAuthClaim?.preAuthClaimRes?.echsClaimSubmissionResponse) {
          if (
            docType?.toUpperCase() === "BILL ATTACHMENTS" ||
            docType?.toUpperCase() === "INVESTIGATION REPORTS" ||
            docType?.toUpperCase() === "CGHS BILL" ||
            docType?.toUpperCase() === "CONSULTATION NOTES" ||
            docType?.toUpperCase() === "CASE SHEET" ||
            docType?.toUpperCase() === "CONSUMABLE DOCUMENT" ||
            docType?.toUpperCase() === "DRUG CERTIFICATE" ||
            docType?.toUpperCase() ===
              "Implant Bill Attachments"?.toUpperCase() ||
            docType?.toUpperCase() === "IMPLANT INVOICE"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Justification for unspecified package"?.toUpperCase() ||
            docType?.toUpperCase() === "PROCEDURE NOTES"?.toUpperCase() ||
            docType?.toUpperCase() === "Post Procedure X Ray"?.toUpperCase() ||
            docType?.toUpperCase() === "CLINICAL NOTES"?.toUpperCase() ||
            docType?.toUpperCase() === "AUDITED BILL" ||
            docType?.toUpperCase() === "HOSPITAL BILL" ||
            docType?.toUpperCase() === "COVID TEST REPORT" ||
            docType?.toUpperCase() ===
              "Unlisted Procedure Docs"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Unlisted Procedure Permission"?.toUpperCase() ||
            docType?.toUpperCase() === "Consultation Notes"?.toUpperCase() ||
            docType?.toUpperCase() === "DISCHARGE SUMMARY"?.toUpperCase() ||
            docType?.toUpperCase() === "DRUG CERTIFICATE"?.toUpperCase() ||
            docType?.toUpperCase() === "DEATH CERTIFICATE"?.toUpperCase() ||
            docType?.toUpperCase() === "ECHS CARD COPY"?.toUpperCase() ||
            docType?.toUpperCase() === "EMERGENCY LETTER"?.toUpperCase() ||
            docType?.toUpperCase() === "OTHERS"?.toUpperCase() ||
            docType?.toUpperCase() === "LAB REPORTS"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "SELF ATTESTED PROFORMA"?.toUpperCase() ||
            docType?.toUpperCase() === "MLC"?.toUpperCase() ||
            docType?.toUpperCase() === "Contingent Bill"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Copy of Cancelled Cheque"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Delay Condonation Letter (Intimation)"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Delay Condonation Letter (Submission)"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Disability Certificate (Intimation)"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Disability Certificate (Submission)"?.toUpperCase() ||
            docType?.toUpperCase() === "Doctor Certificate"?.toUpperCase() ||
            docType?.toUpperCase() === "EIR"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Extended Stay Certificate"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Extension of Stay - Approval"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Extension of Stay - Permission"?.toUpperCase() ||
            docType?.toUpperCase() === "Feedback Form"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Geo-Tagged Photo of Patient"?.toUpperCase() ||
            docType?.toUpperCase() === "Medical Reports"?.toUpperCase() ||
            docType?.toUpperCase() === "Medicine Issue Slip"?.toUpperCase() ||
            docType?.toUpperCase() === "NA Certificate"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Outer Pack of Implants"?.toUpperCase() ||
            docType?.toUpperCase() === "Personal Application"?.toUpperCase() ||
            docType?.toUpperCase() === "Prescription Slip"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Referral Letter (By Polyclinic)"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Emergency Letter (By Hospital)"?.toUpperCase() ||
            docType?.toUpperCase() === "Sanction Letter"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Service Specialist Recommendation"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Stay Extension Documents"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Supplimentary Justification Document"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Supplimentary Sanction Document"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Unlisted Procedure Approval"?.toUpperCase()
          ) {
            const hasDocument = newUpdatedDocumentList?.some(
              (doc) =>
                doc?.documentLabelType?.toUpperCase() === docType?.toUpperCase()
            );
            if (!hasDocument) {
              dispatch(
                updateField({
                  sectionKey: "echsClaimSubmissionResponse",
                  fieldId: docType?.split(" ").join("_"),
                  value: "",
                })
              );
            }
          } else {
            dispatch(
              updateField({
                sectionKey: "echsClaimSubmissionResponse",
                fieldId: docType?.split(" ").join("_"),
                value: "",
              })
            );
          }
          dispatch(
            updateEchsClaimDataField({
              sectionKey: "echsClaimSubmissionResponse",
              fieldId: docType?.split(" ").join("_"),
              visitType:
                patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toLowerCase(),
              updateValues: {
                data: "",
                documentName: "",
              },
              documentUrl: deleteDocument?.documentUrl,
            })
          );
        }
      }
    }
  };

  // useEffect(() => {
  //   if (preAuthClaim?.preAuthClaimRes) {
  //     getAttachmentsWithValues(preAuthClaim?.preAuthClaimRes);
  //   }
  // }, [preAuthClaim?.preAuthClaimRes]);

  const handleDeleteProcedure = async (procedure: any) => {
    try {
      const updatedProcedure = {
        ...JSON.parse(procedure.procedureID || "{}"),
        ...procedure,
        procedureID: JSON.parse(procedure.procedureID).procedureID,
      };
      setDeleteProcedureList((prevList) => [...prevList, updatedProcedure]);
      successMessage("Procedure deleted successfully");
      return true;
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
      return false;
    }
  };

  const getClaimSubmissionData = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id &&
      (patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds ||
        preAuthClaim?.selectedScheme?.portalMetaDataIdsList)
    ) {
      const resp = await dispatch(
        getClaimSubmission({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          portalId:
            patients?.fetchBasicDetails?.casesResponse
              ?.portalMetaDataIds?.[0] ||
            preAuthClaim?.selectedScheme?.portalMetaDataIdsList?.[0],
        })
      );
      if (getClaimSubmission.rejected.match(resp)) {
        errorMessage("CAN NOT ADD CLAIM BEFORE INITIATE PREAUTH !");
      } else if (getClaimSubmission.fulfilled.match(resp)) {
        if (resp?.payload?.errorMessage) {
          errorMessage(resp?.payload?.errorMessage);
        } else {
          if (resp?.payload?.claimSubmissionRes) {
            getAttachmentsWithValues(resp?.payload?.claimSubmissionRes);
          }
          if (
            patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
            "OP"
          ) {
            dispatch(
              setWizardSteps([
                {
                  step: 0,
                  title: "Bill Details",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 1,
                  title: "Procedure Details",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 2,
                  title: "Admission Details",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 3,
                  title: "Ailment Details",
                  canNavigate: true,
                  completed: false,
                },
                {
                  step: 4,
                  title: "Document Details",
                  canNavigate: true,
                  completed: false,
                },

                // {
                //   step: 4,
                //   title: "Line of Treatment",
                //   canNavigate: true,
                //   completed: false,
                // },
                // {
                //   step: 5,
                //   title: "Upload Documents",
                //   canNavigate: true,
                //   completed: false,
                // },
                // {
                //   step: 6,
                //   title: "docuemntDropdowns",
                //   canNavigate: true,
                //   completed: false,
                // },
              ])
            );
          } else {
            dispatch(
              setWizardSteps([
                // {
                //   step: 0,
                //   title: "Diagnosis",
                //   canNavigate: true,
                //   completed: false,
                // },
                {
                  step: 0,
                  title: "Procedure Details",
                  canNavigate: true,
                  completed: false,
                },
                // {
                //   step: 1,
                //   title: "Line of Treatment",
                //   canNavigate: true,
                //   completed: false,
                // },
                {
                  step: 1,
                  title: "Document Details",
                  canNavigate: true,
                  completed: false,
                },

                // {
                //   step: 5,
                //   title: "Upload Documents",
                //   canNavigate: true,
                //   completed: false,
                // },
                // {
                //   step: 6,
                //   title: "docuemntDropdowns",
                //   canNavigate: true,
                //   completed: false,
                // },
              ])
            );
          }
          // dispatch(
          //   setWizardSteps([
          //     {
          //       step: 0,
          //       title: "Bill Details",
          //       canNavigate: true,
          //       completed: false,
          //     },
          //     {
          //       step: 1,
          //       title: "Procedure Details",
          //       canNavigate: true,
          //       completed: false,
          //     },
          //     {
          //       step: 2,
          //       title: "Admission Details",
          //       canNavigate: true,
          //       completed: false,
          //     },
          //     {
          //       step: 3,
          //       title: "Ailment Details",
          //       canNavigate: true,
          //       completed: false,
          //     },
          //     {
          //       step: 4,
          //       title: "Document Details",
          //       canNavigate: true,
          //       completed: false,
          //     },

          //     // {
          //     //   step: 4,
          //     //   title: "Line of Treatment",
          //     //   canNavigate: true,
          //     //   completed: false,
          //     // },
          //     // {
          //     //   step: 5,
          //     //   title: "Upload Documents",
          //     //   canNavigate: true,
          //     //   completed: false,
          //     // },
          //     // {
          //     //   step: 6,
          //     //   title: "docuemntDropdowns",
          //     //   canNavigate: true,
          //     //   completed: false,
          //     // },
          //   ])
          // );
        }
      }
    }
  };

  useEffect(() => {
    if (
      patients?.fetchBasicDetails?.visitInfoResponse?.id === parseInt(visitId)
    ) {
      getClaimSubmissionData();
      props?.stepperForStatus();
    }
  }, [
    preAuthClaim?.selectedScheme?.portalMetaDataIdsList,
    patients?.fetchBasicDetails,
    patients?.fetchBasicDetails?.casesResponse,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds,
    visitId,
  ]);

  useEffect(() => {
    if (
      preAuthClaim?.preAuthClaimRes?.echsClaimSubmissionResponse &&
      patients?.fetchBasicDetails?.visitInfoResponse?.visitType
    ) {
      // Update caseClaimSubmissionId with the new value
      const echsClaimData: any =
        preAuthClaim?.preAuthClaimRes?.echsClaimSubmissionResponse;
      let echsClaimDataCase =
        echsClaimData[
          patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toLowerCase()
        ];
      const newCaseClaimSubmissionId =
        echsClaimDataCase?.["Bill Details"]?.[0]?.caseClaimSubmissionId;

      const portalSubmitCheck =
        echsClaimDataCase?.["Bill Details"]?.[0]?.status;
      if (portalSubmitCheck !== undefined) {
        setPortalSubmission(portalSubmitCheck);
      }
      if (newCaseClaimSubmissionId) {
        setCaseClaimSubmissionId(newCaseClaimSubmissionId);
      } else {
        setCaseClaimSubmissionId(null);
      }
    } else {
      setCaseClaimSubmissionId(123);
    }
  }, [preAuthClaim?.preAuthClaimRes]);

  useEffect(() => {
    if (!props?.claimId) {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        dispatch(
          getPortalData({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          })
        );
      } else {
        dispatch(resetPortalData());
      }
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  useEffect(() => {
    if (!props?.claimId) {
      if (preAuth?.portalData) {
        const {
          casePreAuthEchs,
          casePreAuthIhx,
          casePreAuthCghs,
          casePreAuthStarhealth,
        } = preAuth.portalData;

        if (casePreAuthEchs?.casePreAuthEchsReferralResponse) {
          setNewClaimId(
            casePreAuthEchs.casePreAuthEchsReferralResponse.claimId || null
          );
        } else if (casePreAuthEchs?.casePreAuthEchsEmergencyResponse) {
          setNewClaimId(
            casePreAuthEchs.casePreAuthEchsEmergencyResponse.claimId || null
          );
        } else if (casePreAuthIhx) {
          setNewClaimId(casePreAuthIhx.claimId || null);
        } else if (casePreAuthCghs) {
          setNewClaimId(casePreAuthCghs.claimId || null);
        } else if (casePreAuthStarhealth) {
          setNewClaimId(casePreAuthStarhealth.claimId || null);
        } else {
          setNewClaimId(null);
        }
      } else {
        setNewClaimId(null);
      }
    }
  }, [preAuth?.portalData]);

  const updateOrAddDocument = (
    uploadedDocumentUrl: Array<IDocumentFields>,
    documentRes: IDocumentFields
  ): Array<IDocumentFields> => {
    const updatedDocuments = [...uploadedDocumentUrl];
    const documentIndex = updatedDocuments.findIndex(
      (doc) => doc.documentType === documentRes.documentType
    );

    if (
      documentIndex !== -1 &&
      documentRes?.documentType?.toUpperCase() !== "DOCUMENT" &&
      documentRes?.documentLabelType?.toUpperCase() !== "AUDITED BILL" &&
      documentRes?.documentLabelType?.toUpperCase() !== "HOSPITAL BILL" &&
      documentRes?.documentLabelType?.toUpperCase() !== "COVID TEST REPORT" &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Unlisted Procedure Docs"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Unlisted Procedure Permission"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Consultation Notes"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "DISCHARGE SUMMARY"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "DRUG CERTIFICATE"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "DEATH CERTIFICATE"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "ECHS CARD COPY"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "EMERGENCY LETTER"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "OTHERS"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "LAB REPORTS"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "SELF ATTESTED PROFORMA"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !== "MLC"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Contingent Bill"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Copy of Cancelled Cheque"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Delay Condonation Letter (Intimation)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Delay Condonation Letter (Submission)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Disability Certificate (Intimation)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Disability Certificate (Submission)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Doctor Certificate"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !== "EIR"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Extended Stay Certificate"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Extension of Stay - Approval"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Extension of Stay - Permission"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Feedback Form"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Geo-Tagged Photo of Patient"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Medical Reports"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Medicine Issue Slip"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "NA Certificate"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Outer Pack of Implants"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Personal Application"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Prescription Slip"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Referral Letter (By Polyclinic)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Emergency Letter (By Hospital)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Sanction Letter"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Service Specialist Recommendation"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Stay Extension Documents"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Supplimentary Justification Document"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Supplimentary Sanction Document"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Unlisted Procedure Approval"?.toUpperCase()
    ) {
      updatedDocuments[documentIndex] = {
        ...updatedDocuments[documentIndex],
        documentName: documentRes?.documentName,
        documentUrl: documentRes?.documentUrl,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
      };
    } else {
      updatedDocuments.push({
        documentType: documentRes.documentType,
        documentName: documentRes.documentName,
        documentUrl: documentRes.documentUrl,
        documentLabelType: documentRes?.documentLabelType,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
      });
    }
    return updatedDocuments;
  };

  const handleUploadDocument = async () => {
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id.toString()
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }
    CollectPostData.append("documentType", previewFile.documentType);

    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file?.originFileObj as Blob);
    }

    try {
      const resp = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      );

      if (UploadDocument.fulfilled.match(resp)) {
        const updatedDocuments = updateOrAddDocument(
          preAuthClaim?.uploadedDocumentUrl,
          resp?.payload
        );

        setSelectedFile({ file: {}, documentType: "" });
        if (resp?.payload?.documentUrl) {
          message.success(
            `${resp?.payload?.documentLabelType} UPLOADED SUCCESSFULLY`
          );

          dispatch(setUploadedDocumentUrl(updatedDocuments));
        } else {
          message.error("Please Upload Again");
        }
        setUploadFileModal(false);
      } else if (UploadDocument.rejected.match(resp)) {
        errorMessage("FAILED TO UPLOAD DOCUMENT");
      }
    } catch (error) {
      console.error("Failed to upload document:", error);
    }
  };
  const handleFileChange = (documentType: string) => (e: any) => {
    const maxSize = 15 * 1024 * 1024;
    if (Array.isArray(e)) {
      return e;
    }
    if (e?.fileList[0]?.type !== "application/pdf") {
      errorMessage("File Must be PDF only");
      return;
    }
    // if (e?.file?.size > maxSize) {
    //   errorMessage("File Limit must be less than or equal to 15 MB");
    //   return;
    // }
    if (e?.fileList[0]) {
      setSelectedFile({ file: e?.fileList[0], documentType });
      setPreviewFile({
        url: URL.createObjectURL(e.file),
        name: e.file.name,
        showUpload: true,
        documentType: documentType,
      });
      setUploadFileModal(true);
    }
    return e?.fileList;
  };

  const handleFieldChange = (
    sectionKey: string,
    fieldId: string,
    value: string
  ) => {
    if (
      fieldId?.toLowerCase()?.includes("date") ||
      fieldId?.toLowerCase()?.includes("doa") ||
      fieldId?.toLowerCase()?.includes("dod")
    ) {
      const currentDate = new Date();

      dispatch(
        updateField({
          sectionKey,
          fieldId,
          value: value,
        })
      );
    } else {
      dispatch(updateField({ sectionKey, fieldId, value }));
    }
  };

  const handleSaveChanges = async () => {
    try {
      let dataToSave: any = {};

      if (
        preAuthClaim?.preAuthClaimRes &&
        preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses
      ) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (
                fieldId === "DateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave[fieldId] = value === "" ? null : value;
              } else {
                dataToSave[fieldId] =
                  value === "true" ? true : value === "false" ? false : value;
              }
            });
          }
        );

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }
      } else if (preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (value === "true") {
                dataToSave[fieldId] = true;
              } else if (value === "false") {
                dataToSave[fieldId] = false;
              } else if (
                fieldId === "dateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave[fieldId] = value === "" ? null : value;
              } else {
                dataToSave[fieldId] = value;
              }
            });
          }
        );

        dataToSave["claimNo"] = props?.claimId || newClaimId;
        dataToSave["status"] = true;

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }

        if (!props?.claimId && !newClaimId) {
          errorMessage("Claim Id is not present");
          return;
        }
      } else if (
        preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse
      ) {
        // Add ihxClaimSubmissionResponses to documents
        // dataToSave = {
        //   ...dataToSave,
        //   additionalAmountPaid: false,
        //   claimNo: props?.claimId || newClaimId || "12132",
        //   status: true,
        //   ...preAuthClaim.editedFields.starHealthClaimSubmissionResponse,
        // };
        // delete dataToSave.document;
        // // Add uploadedDocumentUrl to documents if it exists

        // if (caseClaimSubmissionId) {
        //   const formattedDocuments = preAuthClaim?.uploadedDocumentUrl?.map(
        //     (doc: any) => ({
        //       documentType: doc?.documentType,
        //       documentName: doc.id,
        //       documentUrl: doc.data || doc.documentUrl,
        //     })
        //   );

        //   if (preAuthClaim?.uploadedDocumentUrl) {
        //     dataToSave.documents = [...formattedDocuments];
        //   }
        // } else {
        //   if (preAuthClaim?.uploadedDocumentUrl) {
        //     dataToSave.documents = [
        //       ...(dataToSave.documents || []),
        //       ...preAuthClaim.uploadedDocumentUrl.slice(1),
        //     ];
        //   }
        // }

        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (value === "true") {
                dataToSave[fieldId] = true;
              } else if (value === "false") {
                dataToSave[fieldId] = false;
              } else if (
                fieldId === "dateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave[fieldId] = value === "" ? null : value;
              } else {
                dataToSave[fieldId] = value;
              }
            });
          }
        );

        dataToSave["claimNo"] = props?.claimId || newClaimId;
        dataToSave["status"] = true;

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }

        // if (!props?.claimId && !newClaimId) {
        //   errorMessage("Claim Id is not present");
        //   return;
        // }
      } else if (preAuthClaim?.preAuthClaimRes?.echsClaimSubmissionResponse) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (value === "true") {
                dataToSave[fieldId] = true;
              } else if (value === "false") {
                dataToSave[fieldId] = false;
              } else if (
                fieldId === "dateOfDischarge" ||
                fieldId === "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                // dataToSave[fieldId] = value === "" ? null : value;
                const parsedDate = dayjs(value, "DD-MM-YYYY HH:mm:ss");
                dataToSave[fieldId] = parsedDate?.isValid()
                  ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                  : null;
              } else if (fieldId === "items") {
                if (deleteProcedureList?.length > 0) {
                  const updatedItems = value?.filter((procedure: any) => {
                    if (
                      !deleteProcedureList ||
                      deleteProcedureList.length === 0
                    ) {
                      return true;
                    }

                    return !deleteProcedureList?.some(
                      (deletedProcedure: any) =>
                        deletedProcedure.id === procedure.id
                    );
                  });
                  dataToSave["procedureDataList"] = updatedItems?.map(
                    (data: any) => {
                      return {
                        ...JSON.parse(data.procedureID || "{}"),
                        ...data,
                        procedureID: JSON.parse(data.procedureID).procedureID,
                      };
                    }
                  );
                } else {
                  dataToSave["procedureDataList"] = value?.map((data: any) => {
                    return {
                      ...JSON.parse(data.procedureID || "{}"),
                      ...data,
                      procedureID: JSON.parse(data.procedureID).procedureID,
                    };
                  });
                }
              } else {
                dataToSave[fieldId] = value;
              }
            });
          }
        );

        // dataToSave["claimNo"] = props?.claimId || newClaimId;
        dataToSave["status"] = true;

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }

        dataToSave["totalAmount"] =
          preAuthClaim?.editedFields?.echsClaimSubmissionResponse?.claimedAmount?.toString() ||
          null;

        dataToSave["deletedProcedureList"] = deleteProcedureList || [];

        // if (!props?.claimId && !newClaimId) {
        //   errorMessage("Claim Id is not present");
        //   return;
        // }
      }

      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        preAuthClaim?.selectedScheme?.portalMetaDataIdsList
      ) {
        if (!caseClaimSubmissionId) {
          const resp = await dispatch(
            submitClaimSubmission({
              data: {
                ...dataToSave,
                hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
                schemeId: preAuthClaim?.selectedScheme?.schemeMetaDataId,
              },
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              portalId: preAuthClaim?.selectedScheme?.portalMetaDataIdsList[0],
            })
          );

          if (submitClaimSubmission.fulfilled.match(resp)) {
            if (resp?.payload?.errorMessage) {
              errorMessage(resp?.payload?.errorMessage);
            } else {
              successMessage("CLAIM SUBMITTED SUCCESSFULLY");
              props?.onfetchStepper();
              dispatch(resetLocalFiles());
              getClaimSubmissionData();
            }
          } else if (submitClaimSubmission.rejected.match(resp)) {
            errorMessage("CLAIM HAS NOT BEEN SAVED, PLEASE, TRY AGAIN");
            dispatch(resetLocalFiles());
          }
        } else {
          const resp = await dispatch(
            updateClaimSubmission({
              data: {
                ...dataToSave,
                hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
                schemeId: preAuthClaim?.selectedScheme?.schemeMetaDataId,
              },
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              portalId: preAuthClaim?.selectedScheme?.portalMetaDataIdsList[0],
              caseClaimSubmissionId: caseClaimSubmissionId,
            })
          );

          if (updateClaimSubmission.fulfilled.match(resp)) {
            if (resp?.payload?.errorMessage) {
              errorMessage(resp?.payload?.errorMessage);
            } else {
              successMessage("CLAIM UPDATED SUCCESSFULLY");
              props?.onfetchStepper();
              dispatch(resetLocalFiles());
              dispatch(saveChanges());
              dispatch(setUploadedDocumentUrl([]));
              getClaimSubmissionData();
            }
          } else if (updateClaimSubmission.rejected.match(resp)) {
            if (resp?.error?.message) {
              errorMessage(resp?.error?.message);
            }
          }
        }
      }

      setDeleteProcedureList([]);
      // message.success("Changes saved successfully");
    } catch (error: any) {
      if (
        error?.response?.status === 422 &&
        error?.response?.data?.toLowerCase()?.includes("submitted on portal")
      ) {
        message.error("Case Claim submitted on portal we can't update it.");
        // dispatch(toggleEditMode());
      } else {
        console.error("Failed to save changes:", error);
        message.error("Failed to save changes. Please try again.");
      }
      setDeleteProcedureList([]);
    }
  };
  const handleSaveChangeToEdgePro = async () => {
    try {
      let dataToSave: any = {};

      if (
        preAuthClaim?.preAuthClaimRes &&
        preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses
      ) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (
                fieldId === "DateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave[fieldId] = value === "" ? null : value;
              } else {
                dataToSave[fieldId] =
                  value === "true" ? true : value === "false" ? false : value;
              }
            });
          }
        );

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }
      } else if (preAuthClaim?.preAuthClaimRes?.cghsClaimSubmissionResponse) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (value === "true") {
                dataToSave[fieldId] = true;
              } else if (value === "false") {
                dataToSave[fieldId] = false;
              } else if (
                fieldId === "dateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave[fieldId] = value === "" ? null : value;
              } else {
                dataToSave[fieldId] = value;
              }
            });
          }
        );

        dataToSave["claimNo"] = props?.claimId || newClaimId;
        dataToSave["status"] = true;

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }

        // if (!props?.claimId && !newClaimId) {
        //   errorMessage("Claim Id is not present");
        //   return;
        // }
      } else if (
        preAuthClaim?.preAuthClaimRes?.starHealthClaimSubmissionResponse
      ) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (value === "true") {
                dataToSave[fieldId] = true;
              } else if (value === "false") {
                dataToSave[fieldId] = false;
              } else if (
                fieldId === "dateOfDischarge" ||
                "calendar-show" ||
                fieldId?.toLowerCase()?.includes("date")
              ) {
                dataToSave[fieldId] = value === "" ? null : value;
              } else {
                dataToSave[fieldId] = value;
              }
            });
          }
        );

        dataToSave["claimNo"] = props?.claimId || newClaimId;
        dataToSave["status"] = true;

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }

        // if (!props?.claimId && !newClaimId) {
        //   errorMessage("Claim Id is not present");
        //   return;
        // }
      } else if (preAuthClaim?.preAuthClaimRes?.echsClaimSubmissionResponse) {
        Object.entries(preAuthClaim?.editedFields)?.forEach(
          ([sectionKey, fields]) => {
            Object.entries(fields)?.forEach(([fieldId, value]) => {
              if (value === "true") {
                dataToSave[fieldId] = true;
              } else if (value === "false") {
                dataToSave[fieldId] = false;
              } else if (
                fieldId === "dateOfDischarge" ||
                fieldId === "dateOfAdmission" ||
                fieldId.toLowerCase().includes("date")
              ) {
                // const parsedDate = dayjs(value);
                // dataToSave[fieldId] = parsedDate?.isValid()
                //   ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                //   : null;
                const parsedDate = dayjs(value, "DD-MM-YYYY HH:mm:ss");
                dataToSave[fieldId] = parsedDate?.isValid()
                  ? parsedDate.format("DD-MM-YYYY HH:mm:ss")
                  : null;
              } else if (fieldId === "items") {
                if (deleteProcedureList?.length > 0) {
                  const updatedItems = value?.filter((procedure: any) => {
                    if (
                      !deleteProcedureList ||
                      deleteProcedureList.length === 0
                    ) {
                      return true;
                    }

                    return !deleteProcedureList?.some(
                      (deletedProcedure: any) =>
                        deletedProcedure.id === procedure.id
                    );
                  });
                  dataToSave["procedureDataList"] = updatedItems?.map(
                    (data: any) => {
                      return {
                        ...JSON.parse(data.procedureID || "{}"),
                        ...data,
                        procedureID: JSON.parse(data.procedureID).procedureID,
                      };
                    }
                  );
                } else {
                  dataToSave["procedureDataList"] = value?.map((data: any) => {
                    return {
                      ...JSON.parse(data.procedureID || "{}"),
                      ...data,
                      procedureID: JSON.parse(data.procedureID).procedureID,
                    };
                  });
                }
              } else {
                dataToSave[fieldId] = value;
              }
            });
          }
        );

        // dataToSave["claimNo"] = props?.claimId || newClaimId;
        dataToSave["status"] = true;

        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = preAuthClaim?.uploadedDocumentUrl;
        }

        dataToSave["totalAmount"] =
          preAuthClaim?.editedFields?.echsClaimSubmissionResponse?.claimedAmount?.toString() ||
          null;

        dataToSave["deletedProcedureList"] = deleteProcedureList || [];

        // if (!props?.claimId && !newClaimId) {
        //   errorMessage("Claim Id is not present");
        //   return;
        // }
      }

      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        preAuthClaim?.selectedScheme?.portalMetaDataIdsList
      ) {
        const resp = await dispatch(
          submitClaimSubmissionToEdgePro({
            data: {
              ...dataToSave,
              hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
              schemeId: preAuthClaim?.selectedScheme?.schemeMetaDataId,
            },
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            portalId: preAuthClaim?.selectedScheme?.portalMetaDataIdsList[0],
            caseClaimId: caseClaimSubmissionId || null,
          })
        );

        if (submitClaimSubmissionToEdgePro.fulfilled.match(resp)) {
          if (resp?.payload?.errorMessage) {
            errorMessage(resp?.payload?.errorMessage);
          } else {
            successMessage("CLAIM SAVED SUCCESSFULLY");
            dispatch(resetLocalFiles());
            getClaimSubmissionData();
            props?.onfetchStepper();
            dispatch(toggleEditMode);
          }
        } else if (submitClaimSubmissionToEdgePro.rejected.match(resp)) {
          errorMessage("CLAIM HAS NOT BEEN SAVED, PLEASE, TRY AGAIN");
          dispatch(resetLocalFiles());
        }
      }
      dispatch(saveChanges());
      dispatch(setUploadedDocumentUrl([]));
      setDeleteProcedureList([]);

      // message.success("Changes saved successfully");
    } catch (error: any) {
      if (
        error?.response?.status === 422 &&
        error?.response?.data?.toLowerCase()?.includes("submitted on portal")
      ) {
        message.error("Case Claim submitted on portal we can't update it.");
        // dispatch(toggleEditMode());
        setIsEditable(!isEditable);
      } else {
        console.error("Failed to save changes:", error);
        message.error("Failed to save changes. Please try again.");
      }
      setDeleteProcedureList([]);
    }
  };

  useEffect(() => {
    if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
      dispatch(
        fetchSchemeById(
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        )
      );
    }
  }, [patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId]);

  useEffect(() => {
    preAuthClaim?.uploadedDocumentUrl?.forEach((doc) =>
      dispatch(
        updateField({
          sectionKey: "echsClaimSubmissionResponse",
          fieldId: doc?.documentLabelType?.split(" ").join("_"),
          value: doc?.documentUrl,
        })
      )
    );
  }, [preAuthClaim?.uploadedDocumentUrl]);

  const getAttachmentsWithValues = (preAuthClaimData: PreAuthClaimResponse) => {
    const attachmentsWithValues: Array<IDocumentFields> = [];

    if (
      patients?.fetchBasicDetails?.visitInfoResponse?.visitType &&
      preAuthClaimData?.echsClaimSubmissionResponse
    ) {
      const echsClaimData: any = preAuthClaimData?.echsClaimSubmissionResponse;
      let echsClaimDataCase =
        echsClaimData?.[
          patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toLowerCase()
        ];
      const attachments = echsClaimDataCase?.["Document Details"]?.filter(
        (doc: any) =>
          doc?.type === "document-upload" || doc?.type === "document-show"
      );
      attachments?.forEach((attachment: any) => {
        if (
          attachment?.documentsList &&
          attachment?.documentsList?.length > 0
        ) {
          attachment?.documentsList?.forEach((document: IDocumentFields) => {
            attachmentsWithValues.push({
              documentName: document?.documentName,
              documentType: document?.documentType,
              documentUrl: document?.documentUrl,
              id: document?.id,
              deficiencyCheckStatus: document?.deficiencyCheckStatus,
              documentLabelType: document?.documentLabelType,
            });
          });
        }
      });

      dispatch(setUploadedDocumentUrl(attachmentsWithValues));
    }
  };

  // const getAttachmentsWithValues = (preAuthClaimData: PreAuthClaimResponse) => {
  //   const attachmentsWithValues: Array<IDocumentFields> = [];
  //   if (
  //     patients?.fetchBasicDetails?.visitInfoResponse?.visitType &&
  //     preAuthClaimData?.echsClaimSubmissionResponse
  //   ) {
  //     const echsClaimData: any =
  //     preAuthClaimData?.echsClaimSubmissionResponse;
  //     let echsClaimDataCase =
  //       echsClaimData?.[
  //         patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toLowerCase()
  //       ];
  //     const attachments = echsClaimDataCase?.["Document Details"]?.filter(
  //       (doc: any) =>
  //         doc?.type === "document-upload" || doc?.type === "document-show"
  //     );
  //     attachments?.forEach((attachment: any) => {
  //       if (
  //         attachment?.documentsList &&
  //         attachment?.documentsList?.length > 0
  //       ) {
  //         attachment?.documentsList?.forEach((document: IDocumentFields) => {
  //           attachmentsWithValues.push({
  //             documentName: document?.documentName,
  //             documentType: document?.documentType,
  //             documentUrl: document?.documentUrl,
  //             id: document?.id,
  //             deficiencyCheckStatus: document?.deficiencyCheckStatus,
  //             documentLabelType: document?.documentLabelType,
  //           });
  //         });
  //       }
  //     });

  //     dispatch(setUploadedDocumentUrl(attachmentsWithValues));
  //   }
  // };

  useEffect(() => {
    dispatch(setUploadedDocumentUrl([]));
  }, []);

  const handleEditable = () => {
    if (!isEditable && preAuthClaim && preAuthClaim?.preAuthClaimRes) {
      // const initialEditedFields: Record<string, Record<string, any>> = {};
      // Object.keys(preAuthClaim?.preAuthClaimRes).forEach((resKey) => {
      //   const sections = preAuthClaimRes[resKey];
      //   if (sections) {
      //     Object.keys(sections).forEach((key) => {
      //       const caseType = sections[key as keyof PreAuthClaimResponse] && [
      //         sections[key as keyof PreAuthClaimResponse],
      //       ];
      //       if (caseType) {
      //         caseType.forEach((section: any) => {
      //           Object.entries(section)?.forEach(([sectionTitle, fields]) => {
      //             if (Array.isArray(fields)) {
      //               fields.forEach((field: PreAuthClaimField) => {
      //                 if (!initialEditedFields[key]) {
      //                   initialEditedFields[key] = {};
      //                 }

      //                 if (
      //                   preAuthClaim?.preAuthClaimRes
      //                     ?.echsClaimSubmissionResponse
      //                 ) {
      //                   initialEditedFields[key][field.id] = field?.id
      //                     ?.toLowerCase()
      //                     ?.includes("date")
      //                     ? field?.data
      //                       ? dayjs(field?.data, "DD-MM-YYYY HH:mm:ss")
      //                       : null
      //                     : field.data ?? null;
      //                   if (field.type === "document-show") {
      //                     initialEditedFields[resKey][field.id] = [
      //                       {
      //                         documentUrl: field?.data ?? "",
      //                         documentType: "DOCUMENT",
      //                         documentName: field?.documentName ?? "",
      //                       },
      //                     ];
      //                   }
      //                 }
      //               });
      //             }
      //           });
      //         });
      //       }
      //     });
      //   }
      // });
      const initialEditedFields: Record<string, Record<string, any>> = {};
      const preAuthClaimRes: any = preAuthClaim.preAuthClaimRes;

      Object.keys(preAuthClaim?.preAuthClaimRes)?.forEach((resKey) => {
        const sections = preAuthClaimRes[resKey];
        if (sections) {
          Object.keys(sections)?.forEach((key) => {
            const caseType = sections[key as keyof PreAuthClaimResponse];
            if (caseType) {
              //caseType?.forEach((section:any) => {
              Object.entries(caseType)?.forEach(([sectionTitle, fields]) => {
                if (
                  Array.isArray(fields) &&
                  !sectionTitle?.toLowerCase()?.includes("procedure")
                ) {
                  fields?.forEach((field: PreAuthClaimField) => {
                    if (!initialEditedFields[resKey]) {
                      initialEditedFields[resKey] = {};
                    }
                    initialEditedFields[resKey][field?.id] = field?.id
                      ?.toLowerCase()
                      ?.includes("date")
                      ? field?.data
                        ? // ? dayjs(field?.data, "DD-MM-YYYY HH:mm:ss")
                          parseDate(field?.data)
                        : null
                      : field.data ?? null;
                  });
                } else if (
                  sectionTitle?.toLowerCase()?.includes("procedure") &&
                  Array.isArray(fields)
                ) {
                  const items = fields?.map((item) => ({
                    expenseUnit: item?.expenseUnit ?? null,
                    expenseCode: item?.expenseCode ?? null,
                    admissibleRate: item?.admissibleRate ?? null,
                    hospitalRate: item?.hospitalRate ?? null,
                    hospitalAmount: item?.hospitalAmount ?? null,
                    hospitalRemark: item?.hospitalRemark ?? null,
                    id: item?.id ?? null,
                    procedureID: JSON.stringify({
                      rateType: item?.rateType ?? null,
                      expenseType: item?.expenseType ?? null,
                      expenseCode: item?.expenseCode ?? null,
                      procedureID: item?.procedureID ?? null,
                      expenseName: item?.expenseName ?? null,
                      normalRate: item?.normalRate ?? null,
                      admissibleRate: item?.admissibleRate ?? null,
                    }),
                  }));

                  initialEditedFields[resKey] = {
                    ...initialEditedFields[resKey],
                    items: items?.length > 0 ? items : null,
                  };
                }
              });
              //});
            }
          });
        }
      });

      dispatch(
        updateField({
          sectionKey: "all",
          fieldId: "all",
          value: initialEditedFields,
        })
      );
    }
    setIsEditable(!isEditable);
  };
  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      setDownloadingDocumentUrl(url);
      setIsDownloadingDocument(true);
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    } catch (err: any) {
      errorMessage("Please, Try again later");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    }
  };

  const [isApproved, setIsApproved] = useState<any>(false);
  const [isApprovedInitiated, setIsApprovedInitiated] =
    useState<boolean>(false);

  useEffect(() => {
    if (preAuthClaim?.preAuthClaimRes?.echsClaimSubmissionResponse) {
      setIsApproved(
        preAuthClaim?.preAuthClaimRes?.echsClaimSubmissionResponse[0]?.[
          "approved"
        ]
      );
    }
  }, [preAuthClaim?.preAuthClaimRes]);

  const handleApprove = async () => {
    try {
      setIsApprovedInitiated(true);
      const formData = {
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        stage: "Claim",
        approved: true,
      };
      const res = await submitApproval(formData);
      setIsApproved(true);
      setIsApprovedInitiated(false);
    } catch (err) {
      errorMessage("Please, Try again later");
      setIsApprovedInitiated(false);
      setIsApproved(false);
    }
  };

  return (
    <div>
      {preAuthClaim?.isLoading ? (
        <Loader />
      ) : (
        <PreAuthClaimEchs
          activeStep={activeStep}
          allWizardSteps={allWizardSteps}
          onNext={handleNext}
          onPrevious={handlePrevious}
          onComplete={handleComplete}
          handleTabsChange={handleTabsChange}
          error={error}
          handleFileChange={handleFileChange}
          handleSaveToEdgePro={handleSaveChangeToEdgePro}
          handleDeleteList={handleDeleteList}
          preAuthClaimData={preAuthClaim?.preAuthClaimRes}
          caseClaimSubmissionId={caseClaimSubmissionId}
          editedFields={preAuthClaim?.editedFields}
          onFieldChange={handleFieldChange}
          visitType={patients?.fetchBasicDetails?.visitInfoResponse?.visitType}
          uploadedDocumentUrl={preAuthClaim?.uploadedDocumentUrl}
          handleSaveChangesEchs={handleSaveChanges}
          isLoading={preAuthClaim?.isSubmit}
          isEditable={isEditable}
          handleEditable={handleEditable}
          handleSetDocumentUrl={handleSetDocumentUrl}
          handleOpen={handleOpen}
          handleDownloadDocument={handleDownloadDocument}
          isDownloadingDocument={isDownloadingDocument}
          downloadingDocumentUrl={downloadingDocumentUrl}
          isSubmit={isSubmit}
          isSubmitted={isSubmitted}
          handleDeficiencyModal={handleDeficiencyModalOpen}
          closeDeficiencyModal={closeDeficiencyModal}
          deficiencyModal={deficiencyModal}
          deficiencyQuestions={patients?.deficiencyCheckQuestions}
          previewDocumentUrl={previewDocumentUrl}
          setDocumentName={setDocumentName}
          handleDeficiencyModalAfterSave={handleDeficiencyModalAfterSave}
          portalSubmission={portalSubmission}
          procedureDropDown={preAuthClaim?.procedureDropDown}
          handleDeleteProcedure={handleDeleteProcedure}
          handleApprove={handleApprove}
          isApproved={isApproved}
          isApprovedInitiated={isApprovedInitiated}
          form={form}
          nextStage={props?.nextStage}
          setMoveToNext={props?.setMoveToNext}
        />
      )}
      <FilePreviewModal
        isVisible={uploadFileModal}
        onClose={handleCancel}
        fileUrl={previewFile.url}
        fileName={previewFile.name}
        documentType={previewFile.documentType}
        handleUpload={handleUploadDocument}
        showUploadButton={previewFile.showUpload}
        key={selectedFile?.file?.uid || "no-file"}
        isLoading={preAuthClaim?.isLoading}
      />
      <RightSidePreviewModal
        key={documentUrl}
        documentUrl={documentUrl}
        handleCancel={handleCancelPreview}
        open={previewDocument}
      />
      <DocumentDeficiencyModal
        key={previewDocumentUrl}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        documentUrl={previewDocumentUrl}
        documentName={documentName}
        handleDownloadDocument={handleDownloadDocument}
        isDownloadingDocument={isDownloadingDocument}
        downloadingDocumentUrl={downloadingDocumentUrl}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        type={"claim"}
      />
    </div>
  );
};

export default PreAuthClaimContainerEchs;
